import { AttainmentBar } from 'ui-deal-management-components-lib/components/attainmentBar/AttainmentBar';
import I18n from 'I18n';
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import UIIcon from 'UIComponents/icon/UIIcon';
import { EERIE } from 'HubStyleTokens/colors';
import GoalsOverviewLink from './GoalsOverviewLink';
import { isMissingCurrencyCode } from '../../utils/currency';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AttainmentBarTeamGoal = ({
  goal,
  onClickAttainmentBar,
  value,
  isLoadingGoal = false
}) => {
  const formattedGoal = isMissingCurrencyCode(goal) ? '--' : I18n.formatIntlCurrency(goal.value, {
    currencyCode: goal.currencyCode
  });
  return /*#__PURE__*/_jsx(AttainmentBar, {
    goal: isMissingCurrencyCode(goal) ? 0 : goal.value,
    value: value.value,
    onClickAttainmentBar: onClickAttainmentBar,
    renderGoal: () => /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: 'repOverviewTable.attainmentCell.teamGoal.infoText'
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(GoalsOverviewLink, {
            onClickAttainmentBar: onClickAttainmentBar
          })
        })]
      }),
      placement: "right",
      maxInlineSize: "265px",
      disabled: isLoadingGoal,
      children: /*#__PURE__*/_jsx("span", {
        children: isLoadingGoal ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "repOverviewTable.cells.loadingGoals"
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "repOverviewTable.cells.goal",
            options: {
              value: formattedGoal
            }
          }), /*#__PURE__*/_jsx(UIIcon, {
            name: "info",
            color: EERIE,
            className: "m-left-1"
          })]
        })
      })
    }),
    renderValue: () => /*#__PURE__*/_jsx(FormattedIntlCurrency, {
      value: value.value,
      currencyCode: value.currencyCode
    })
  });
};